import {
  ResendMessageRequestPayload,
  ViewSentEmailRequestPayload,
} from 'modules/sentMessage/types';
import { ApiResponse, getRaw, postRaw } from 'services/api';
import { generateQueryString } from 'utils/helpers';

export const SENT_MESSAGE_URL = '/triggered/viewSentEmail.json';
export const RESEND_MESSAGE_URL = '/triggered/resendMessage';

export const fetchSentMessage = (payload: ViewSentEmailRequestPayload): Promise<ApiResponse> => {
  const query = generateQueryString(payload);
  const url = `${SENT_MESSAGE_URL}${query}`;
  return getRaw(url);
};

export const resendMessage = (payload: ResendMessageRequestPayload) =>
  postRaw(RESEND_MESSAGE_URL, payload);
